import React from 'react';
import {Typography} from '@mui/material';

const ImageRenderer = ({node, idx, inTable = false, inListItem = false, prefixText}) => {
    if (!node) return null;
    const key = `node-${idx}`;
    const attrs = node.attrs || {};
    const {src, alt, title, caption, width, height, error} = attrs;
    const figureNumber = attrs.figure_number ?? null;
    const getClassification = (n) => n?.attrs?.classification_access || 'U';

    // If there's an explicit error or missing src, show a light fallback
    if (error) {
        return (
            <Typography key={key} component="div" color="error" sx={{mb: inTable ? 0 : 2}}>
                Image failed to load{alt ? `: ${alt}` : ''}
            </Typography>
        );
    }
    if (!src) {
        return null;
    }
    const captionText = title || caption;

    return (
        <Typography key={key} component="div" sx={{mb: inTable ? 0 : 2}}>
            {prefixText && `${prefixText} `}
            {!inListItem && !prefixText && `(${getClassification(node)}) `}
            <img
                src={src}
                alt={alt || ''}
                title={title || undefined}
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    border: '1px solid #cde'
                }}
                width={typeof width === 'number' ? width : undefined}
                height={typeof height === 'number' ? height : undefined}
            />
            <Typography variant="caption" component="div" sx={{mt: 0.5, color: 'text.secondary'}}>
                {figureNumber != null ? `Figure ${figureNumber}. ` : ''}{captionText}
            </Typography>
        </Typography>
    );
};

export default ImageRenderer;
